// src/pages/AnimatedBackground.jsx
import React from "react";
import styled from "styled-components";

const Background = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: -1;

  background: radial-gradient(circle at top, #0b1020, #020617);
`;

const Bubble = styled.span`
  position: absolute;
  bottom: -120px;

  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;

  background: ${({ color }) => color};
  opacity: 0.35;

  left: ${({ left }) => left}%;
  animation: rise ${({ duration }) => duration}s linear infinite;

  filter: blur(1px);

  @keyframes rise {
    from {
      transform: translateY(0) scale(1);
      opacity: 0.3;
    }
    to {
      transform: translateY(-140vh) scale(1.2);
      opacity: 0;
    }
  }
`;

export default function AnimatedBackground() {
  const bubbles = Array.from({ length: 26 }).map((_, i) => ({
    id: i,
    size: Math.random() * 60 + 20,
    left: Math.random() * 100,
    duration: Math.random() * 18 + 12,
    color: i % 2 === 0 ? "#4f8cff" : "#ffffff",
  }));

  return (
    <Background>
      {bubbles.map((b) => (
        <Bubble
          key={b.id}
          size={b.size}
          left={b.left}
          duration={b.duration}
          color={b.color}
        />
      ))}
    </Background>
  );
}
